<template>
  <div>
    <Head title="Queue" />
    <h1 class="mb-8 text-3xl font-bold">Queue</h1>
    <div class="flex items-center justify-between mb-6">
      <search-with-dropdown-filter v-model="search.search" class="mr-4 w-full max-w-md">
        <label class="block text-gray-700">By Dates:</label>
        <select v-model="search.deliveryDate" class="form-select mt-1 w-full">
          <option value="">-Select date-</option>
          <option value="delivery_date">Delivery Date</option>
          <option value="order_date">Order Date</option>
        </select>
      </search-with-dropdown-filter>
      <search-channel v-model="search.channel" :channels="channels" class="mr-0 w-full max-w-md mr-3" />
      <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md" @reset="reset" /> 
      <div class="flex items-center justify-between mb-6 mt-6">
        <a v-if="isBulk" class="btn-orange" href="#" @click="submitBulk">
          <span>Add</span>
          <span class="hidden md:inline">&nbsp;to PickList</span>
        </a>
      </div>
    </div>
    <div class="flex items-center justify-between mb-6">
      <span v-if="isBulk && queueVolume"><strong>Total Volume: {{ queueVolume.volume }}</strong></span>
      <a
        v-if="(orders.data.length > 0 && url())"
        class="btn-orange px-3 py-2 text-xs cursor-pointer"
        :href="`/queue/download${url()}`"
        download
        target="__blank"
      >
        <span>Download</span>
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <!--Order Date, Delivery Date, Order Number, Customer Name, Region, Zone, City, Address-->
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">#</th>
          <th class="pb-3 pt-3 px-3">Order Date</th>
          <th class="pb-3 pt-3 px-3">Delivery Date</th>
          <th class="pb-3 pt-3 px-3">Order Number</th>
          <th class="pb-3 pt-3 px-3">Customer Name</th>
          <th class="pb-3 pt-3 px-3">Region</th>
          <th class="pb-3 pt-3 px-3">Zone</th>
          <th class="pb-3 pt-3 px-3">City</th>
          <th class="pb-3 pt-3 px-3">Address</th>
          <th class="pb-3 pt-3 px-3">CBM</th>
        </tr>
        <tr v-for="order in orders.data" :key="order.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t pl-2">
            <input
              :id="`item-${order.id}`"
              type="checkbox"
              :value="order.id"
              class="flex items-center px-3 py-3 focus:text-orange-500 ml-2"
              @click="buildBulk(order)"
            />
          </td>
          <td class="border-t" @click="openModal(order)">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ order.date }}
            </span>
          </td>
          <td class="border-t" @click="openModal(order)">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ order.delivery_date }}
            </span>
          </td>
          <td class="border-t" @click="openModal(order)">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ order.order_no }}
            </span>
          </td>
          <td class="border-t" @click="openModal(order)">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ order.customer }}
            </span>
          </td>
          <td class="border-t" @click="openModal(order)">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ order.region }}
            </span>
          </td>
          <td class="border-t" @click="openModal(order)">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ order.zone }}
            </span>
          </td>
          <td class="border-t" @click="openModal(order)">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ order.town }}
            </span>
          </td>
          <td class="border-t" @click="openModal(order)">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ order.address }}
            </span>
          </td>
          <td class="border-t" @click="openModal(order)">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ order.cbm }}
            </span>
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="12">No data found</td>
        </tr>
      </table>
    </div>
    <br>
    <span v-if="isBulk && queueVolume" class="mt-3"><strong>Total Volume: {{ queueVolume.volume }}</strong></span>
    <pagination class="mt-6" :links="orders.links" />
  </div>
  <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1>
              {{ orderNo }} - {{ orderCustomer }} <span class="approved">[{{ orderStatus }}]</span>
            </h1>
          </div>
          <div v-if="details.length > 0" class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-3 pt-3 px-3">#</th>
                  <th class="pb-3 pt-3 px-3">SKU</th>
                  <th class="pb-3 pt-3 px-3">Description</th>
                  <th class="pb-3 pt-3 px-3">Quantity</th>
                  <th class="pb-3 pt-3 px-3">Unit Price</th>
                  <th class="pb-3 pt-3 px-3">Discount (%)</th>
                  <th class="pb-3 pt-3 px-3 text-end float-right">Amount</th>
                </tr>
                <tr v-for="(item, index) in details" :key="index">
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ index+1 }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.sku }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3" style="word-wrap: break-word !important; word-break: break-all !important; white-space: normal !important; width: 30%;">
                    <span class="flex items-left px-3">{{ item.description }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">{{ item.quantity }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">{{ item.unit_cost }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">{{ item.discount }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 text-end justify-end">{{ item.amount }}</span>
                  </td>
                </tr>
                <tr v-if="orderObj.delivery_fees && orderObj.delivery_fees > 0">
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ details.length + 1 }}</span></td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ orderObj.transport_name }}</span></td>
                      <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ orderObj.transport_description }}</span></td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">1</span>
                  </td>
                  <td class="w-px pb-3 pt-3  border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{ orderObj.transport_amount }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">0</span>
                  </td>
                  <td class="w-px pb-3 pt-3  border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{ orderObj.transport_amount }}</span>
                  </td>
                </tr>
                <tr v-if="orderObj.voucherInfo && orderObj.voucherInfo.code && orderObj.has_discount_voucher == 0">
                  <td class="w-px border-t pb-3 pt-3"><span class="flex items-left px-3">-</span></td>
                  <td class="w-px border-t pb-3 pt-3" colspan="5">
                    <span class="flex items-left px-3"> Voucher Code: #{{ orderObj.voucherInfo.code }} - {{ orderObj.voucherInfo.value }} {{ orderObj.voucherInfo.type === 'Percentage' ? '%' : '' }}</span></td>
                  <td class="pb-3 pt-3  border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{ orderObj.voucherInfo.voucher_amount }}</span>
                  </td>
                </tr>
                <tr>
                  <th class="pb-3 pt-3  border-t border-b">Total</th>
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{ total }}</span>
                  </th>
                </tr>
              </table>
            </div>
          </div>
          <div v-else class="p-5">No order details not found.</div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span v-if="details.length > 0" class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="approveOrder(selectedOrder)">
                Add to Picklist
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeModal">
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isApproveOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1>Add to Picklist</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <p class="mb-2">You are about to add the following order details to a Picklist.</p>
              <p class="mt-2">Do you wish to continue?</p>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="submitPicklist">
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeApproveModal">
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isAddedToPicklistOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1>Add order to picklist</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              Order item has been added to Picklist.
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="closeApprovalok">
                Ok
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div v-if="queueMessagesOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1>Add order to picklist</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              {{ queueMessage }}
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="closeApprovalok">
                Ok
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
    
<script>
import { Head } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchWithDropdownFilter from '@/Shared/SearchWithDropdownFilter'
import SearchChannel from '@/Shared/SearchChannel'
import DateRange from '@/Shared/DateRange'
import axios from 'axios'
    
export default {
  components: {
    Head,
    Pagination,
    SearchWithDropdownFilter,
    SearchChannel,
    DateRange,
  },
  layout: Layout,
  props: {
    filters: Object,
    orders: Object,
    channels: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        orders: null,
      }),
      search: {
        search: this.filters.search,
        channel: this.filters.channel,
        dateValue: this.filters.dateValue,
        deliveryDate: this.filters.deliveryDate
      },
      dates: [
        { name: 'Order-Date'},
        { name: 'Delivery-Date'}
      ],
      isOpen: false,
      orderNo: null,
      orderStatus: null,
      orderCustomer: null,
      details: [],
      picklistDetails: {},
      total: 0,
      selectedOrder: null,
      isApproveOpen: false,
      orderMessage: '',
      isAddedToPicklistOpen: false,
      queueMessagesOpen: false,
      queueMessage: null,
      bulkOptions: [],
      isBulk: false,
      queueVolume: null,
      orderObj: null,
    }
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/list-dispatches', pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    openModal(data) {
      this.details = []
      this.orderObj = data
      this.isOpen = true
      this.details = data.details
      this.orderNo = `${data.order_no}/${data.customer}/${data.town}`
      this.orderStatus = data.status
      this.orderCustomer = data.name
      this.total = data.amount
      this.selectedOrder = data.id
    },
    closeModal() {
      this.isOpen = false
    },
    approveOrder(data) {
      this.isApproveOpen = true
      /*this.picklistDetails.Order = data.order_no
      this.picklistDetails.Sku = data.sku
      this.picklistDetails.Description = data.description
      this.picklistDetails.Customer = data.customer
      this.picklistDetails.City = data.town*/
      this.selectedOrder = data
    },
    closeApproveModal() {
      this.isApproveOpen = false
    },
    submitPicklist() {
      this.form.post(`/add-order-to-picklist/${this.selectedOrder}`, {
        onSuccess: () => {
          this.bulkOptions = null
          this.isOpen = false
          this.isBulk = false
          this.queueMessagesOpen = false
          this.isApproveOpen = false
          this.isAddedToPicklistOpen = false
        }
      })
    },
    closeApprovalok() {
      this.isAddedToPicklistOpen = false
      this.queueMessagesOpen = false
    },
    buildBulk(order) {
      const inpt = `#item-${order.id}`
      if ($(inpt).is(':checked')) {
        this.bulkOptions.push({ id: $(inpt).val() })
      } else {
        const selectedItem = $(inpt).val()
        const selected = { id: selectedItem }
        const items = this.bulkOptions.filter((item) => item.id !== selected.id)
        this.bulkOptions = items
      }
      if (this.bulkOptions.length > 0) {
        this.isBulk = true
      } else {
        this.isBulk = false
      }
      this.form.orders = this.bulkOptions
      axios.post(`/dispatch/queue/volume/search`, this.form).then(response => {
        this.queueVolume = response.data
      })

    },
    submitBulk(e) {
      e.preventDefault()
      this.form.post('/add-bulk-orders-to-picklist', {
        onSuccess: () => {
          this.isBulk = false
          this.queueMessagesOpen = false
        },
      })
    },
    url() {
      let query = '';
      if (this.search.channel) {
        if (query) {
          query += '&';
        }
        query += `channel=${this.search.channel}`;
      }
      if (this.search.dateValue) {
        if (query) {
          query += '&';
        }
        query += `dateValue=${this.search.dateValue}`;
      }
      if (this.search.search) {
        if (query) {
          query += '&';
        }
        query += `search=${this.search.search}`;
      }
      if (this.search.deliveryDate) {
        if (query) {
          query += '&';
        }
        query += `deliveryDate=${this.search.deliveryDate}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
  },
}
</script>
  
  <style>
  .modal-wrapper h1 {
    font-size: 20px;
    font-weight:bold;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .approved {
    color: green;
  }
  </style>
    